module.exports = __webpack_public_path__ + "src/assets/img/SND2_2.32cc38f6.jpg";